import { Employee } from './employee.model';

export enum AdvanceTypes {
    Static = 'static',
    Additional = 'additional'
}

export enum AdvanceCloseActions {
    TransferAdvance = 'transferAdvance',
    ReturnToEmployee  = 'returnToEmployee',
    ReturnFromEmployee = 'returnFromEmployee',
    CloseAdvance = 'closeAdvance',
}

export interface AdvanceType {
    name: AdvanceTypes;
}

export interface AdvanceStatus {
    name: string;
}
export class Advance {

    constructor(
        public id?: number,
        public type?: AdvanceType,
        public name?: string,
        public status?: AdvanceStatus,
        public value?: number,
        public createdAt?: string,
        public updatedAt?: string,
        public delegationNumber?: string,
        public employee?: Employee | number | undefined,
        public leftValue?: number,
        public unsettledValue?: number,
        public currencyCode?: string,
        public closingComment?: string,
        public openingComment?: string,
        public canCancel?: boolean,
    ) { }

    static adapt(item: any): Advance {

        return new Advance(
            item.id,
            item.type,
            item.name,
            item.status,
            item.value,
            item.createdAt,
            item.updatedAt,
            item.delegationNumber,
            item.employee ? typeof item.employee === 'number' ? item.employee : Employee.adapt(item.employee) : undefined,
            item.leftValue,
            item.unsettledValue,
            item.currencyCode ? item.currencyCode : 'PLN',
            item.closingComment,
            item.openingComment,
            item.canCancel,
        );
    }
}

